import { ScrollTrigger } from 'gsap/ScrollTrigger';
import SmoothScroll from './SmoothScroll.js';
import MouseTrail from './MouseTrail.js';
import InvaderGame from './InvaderGame.js';
import Schedule from './Schedule.js';
import HeroParallax from './HeroParallax.js';
import RulesAjax from './RulesAjax.js';
import TournamentMenu from './TournamentMenu.js';
import HeaderScroll from './HeaderScroll.js';
import ConsentLinks from './ConsentLinks.js';
import HoverAudio from './HoverAudio.js';
import GalleryLightbox from './GalleryLightbox.js';
import PageTransitions from './PageTransitions.js';

class MotionRegistry {
  constructor() {
    this.modules = [];
    this.boot = this.boot.bind(this);
    this.destroyModules = this.destroyModules.bind(this);
    this.destroy = this.destroy.bind(this);

    this.persistent = [new SmoothScroll(), new MouseTrail()];
    this.pageTransitions = new PageTransitions({
      onView: this.boot,
    });

    this.boot();
  }

  boot() {
    this.destroyModules();

    this.modules = [
      new InvaderGame(),
      new Schedule(),
      new HeroParallax(),
      new RulesAjax(),
      new TournamentMenu(),
      new HeaderScroll(),
      new ConsentLinks(),
      new HoverAudio(),
      new GalleryLightbox(),
    ];

    ScrollTrigger.refresh();
  }

  destroyModules() {
    this.modules.forEach((instance) => {
      if (instance && typeof instance.destroy === 'function') {
        instance.destroy();
      }
    });

    this.modules = [];
  }

  destroy() {
    this.destroyModules();
    this.persistent.forEach((instance) => instance.destroy());

    if (this.pageTransitions && typeof this.pageTransitions.destroy === 'function') {
      this.pageTransitions.destroy();
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.__defaultwpMotion = new MotionRegistry();
});
